import React from 'react';
import { HStack } from '~/components/gluestack/hstack';
import { Tooltip, TooltipContent, TooltipText } from '~/components/gluestack/tooltip';
import { Box } from '~/components/gluestack/box';
import { useTranslation } from 'react-i18next';
import { SocialTagIcon } from './SocialTagIcon';

interface SocialTagIconsProps {
  tags: string[];
  size?: number;
  className?: string;
}

export function SocialTagIcons({ tags, size = 18, className }: SocialTagIconsProps) {
  const { t } = useTranslation('domain');

  if (!tags?.length) return null;

  return (
    <HStack className={`items-center gap-1 ${className ?? ''}`}>
      {tags.map((tag) => {
        const label = t(`ProfileTags.SocialTags.${tag}`, tag);

        return (
          <Tooltip key={tag} placement="top" trigger={(triggerProps) => (
            <Box {...triggerProps}>
              <SocialTagIcon tag={tag} size={size} />
            </Box>
          )}>
            <TooltipContent className="bg-background-700">
              <TooltipText className="text-typography-50">{label}</TooltipText>
            </TooltipContent>
          </Tooltip>
        );
      })}
    </HStack>
  );
}
